import React, { useEffect, useState } from "react";
import "./edit_item_packing.css";
import { Form, Input, Button, Space } from "antd";
import { PackingListItem } from "../../components/hoc_packing_list";

interface EditItemPackingProps {
    initialData: PackingListItem | null;
    onClose: () => void;
    onSave: (updatedItem: PackingListItem) => void;
}

const EditItemPacking: React.FC<EditItemPackingProps> = ({ initialData, onClose, onSave }) => {
    const [form] = Form.useForm();
    const [isprogress, setIsprogress] = useState(false);

    useEffect(() => {
        if (initialData) {
            form.setFieldsValue({
                item_code: initialData.item_code,
                item_name: initialData.item_name,
                uom: initialData.uom,
                warehouse: initialData.location,
                location: initialData.location,
                picking_quantity: initialData.picking_quantity,
                packing_quantity: initialData.packing_quantity,
                remark: initialData.remark,
            });
        } else {
            form.resetFields();
        }
    }, [initialData, form]);

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const handleOkClick = () => {
         if (isprogress) return; 
         setIsprogress(true);
        form.validateFields().then(values => {
            if (initialData) {
                const updatedItem: PackingListItem = {
                    ...initialData,
                    packing_quantity: values.packing_quantity,
                    remark: values.remark,
                };
                onSave(updatedItem);
                onClose();
            }
            setIsprogress(false);
        }).catch(info => {
            console.log('Validasi Gagal:', info);
            setIsprogress(false);
        });
    };

    return (

        <div id="i2bt" style={transformStyle}>
            <div className="gjs-grid-row" id="i81g">
                <div className="gjs-grid-column" id="i9nc">
                    <Form
                        form={form}
                        layout="horizontal"
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Item Code Picking"
                            name="item_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Uom"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Location"
                            name="location"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Picking Qty"
                            name="picking_quantity"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Packing Qty"
                            name="packing_quantity"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    validator: (_, value) => {
                                        const pickingQty = form.getFieldValue('picking_quantity');
                                        const packingQty = parseFloat(value);
                                        const parsedPickingQty = parseFloat(pickingQty);
                                        if (packingQty > parsedPickingQty) {
                                            return Promise.reject(new Error('Advantages of Packing'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="" />
                        </Form.Item>
                    </Form>
                    <Space style={{ marginTop: '20px', justifyContent: 'flex-end', width: '100%' }}>
                       <Button type="primary" onClick={handleOkClick} loading={isprogress} disabled={isprogress}>OK</Button> 
                    </Space>
                </div>
            </div>
        </div>
    );
};

export default EditItemPacking;